/**
 * Escucha varias consultas de Firestore y entrega la unión de sus documentos.
 *
 * La supervisora de empresa hace una consulta por empresa (las reglas solo le
 * dejan leer las suyas). Si UNA falla, las demás siguen mostrando lo que
 * cargaron: se vacía solo la parte de la consulta que falló (su listener ya
 * murió y lo que tenía puede estar viejo) y el error se reporta aparte.
 *
 * onUpdate({ docs, error }): docs es la unión de las partes; error es el
 * primero de las consultas que están fallando, o null si ninguna falla.
 * Devuelve la función que corta todos los listeners.
 *
 * Módulo puro (solo usa q.onSnapshot), para poder testearlo directo.
 */
export const subscribeMany = (queries, onUpdate) => {
  const list = Array.isArray(queries) ? queries : [];
  const parts = list.map(() => []);
  const errors = list.map(() => null);
  const emit = () => onUpdate({
    docs: parts.flat(),
    error: errors.find((e) => e) || null,
  });
  if (!list.length) emit();
  const offs = list.map((q, i) => q.onSnapshot(
    (s) => {
      parts[i] = s.docs.map((d) => ({ id: d.id, ...d.data() }));
      errors[i] = null;
      emit();
    },
    (e) => {
      parts[i] = [];
      errors[i] = e || new Error('No se pudo leer la consulta');
      emit();
    },
  ));
  return () => offs.forEach((off) => off());
};
